/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { CurrencyValueModel, ServiceVoModel, ShipmentStatusChangeDtoModel } from '@well/domain';
import { HandoverDtoModel } from '@well/delivery-libs/handover/domain';
import { CostCenterResourceItemVO } from '@well/delivery-libs/cost-center/domain';
import {
  ContractTariffItemVoModel,
  PackageContractTariffItemVoModel
} from '@well/delivery-libs/contract-management/shell-domain';
import { ShipmentFlowType } from './shipment-flow-type.enum';
import { PackageDtoModel } from '@well/delivery-libs/packages/domain';
import { Maybe } from '@irian-ro/util-functions';
import { ProductCustomsClearanceDtoModel } from '@well/product-customs-clearance/domain';
import { ShipmentVehicleDtoModel } from './shipment-vehicle-dto.model';
import { ShipmentDriverDtoModel } from './shipment-driver-dto.model';
import { ShipmentState } from './shipment-state';

export class ShipmentRequestDtoModel extends JSONable {
  uuid: string | null | undefined= null;

  offerUuid: string | null = null;

  packages: PackageDtoModel[] = [];

  productCustomsClearanceDTOS: ProductCustomsClearanceDtoModel[] | null = [];

  pickup: HandoverDtoModel | null = null;

  delivery: HandoverDtoModel | null = null;

  budget: Maybe<number> = null;

  locked: boolean | null = null;

  type: string | null = null;

  stackable: boolean | null = null;

  cargoValue:Maybe<number> = null;

  serviceVo: ServiceVoModel | null = null;

  tags: string[] | null = null;

  version: number | null = null;

  shipmentBaseUuid: string | null = null;

  shipmentCustomerTemplateUuid: string | null = null;

  shipmentVendorTemplateUuid: string | null = null;

  pinned: boolean | null = null;

  budgetCurrencyValue: CurrencyValueModel | null = null;

  cargoCurrencyValue: CurrencyValueModel | null = null;

  shipmentFlowType: ShipmentFlowType | null = null;

  externalReference: string | null = null;

  scheduledShipmentUuid: string | null = null;

  costCenter: CostCenterResourceItemVO | null = null;

  contractTariffItemVO: ContractTariffItemVoModel | null = null;
  packageContractTariffItemVOs: PackageContractTariffItemVoModel[] = [];

  cronExpression: string | null = null;

  recurrenceEndDate: string | null = null;

  shipmentStatusChangeDTO: ShipmentStatusChangeDtoModel | null = null;

  transportProjectUuid: string | null = null;

  dispatcherUuid: string | null = null;

  plannerUuid: string | null = null;

  shipmentVehicleDTO: ShipmentVehicleDtoModel | null = null;
  shipmentDriverDTO: ShipmentDriverDtoModel | null = null;

  series: string | null = null;

  state: ShipmentState = new ShipmentState();

  constructor() {
    super();
    this.pickup = new HandoverDtoModel();
    this.delivery = new HandoverDtoModel();
    this.shipmentVehicleDTO = new ShipmentVehicleDtoModel();
    this.shipmentDriverDTO = new ShipmentDriverDtoModel();
  }

  public static getEmptyShipmentDto() {
    const shipment = new ShipmentRequestDtoModel();
    shipment.pickup = new HandoverDtoModel();
    shipment.delivery = new HandoverDtoModel();
    shipment.shipmentVehicleDTO = new ShipmentVehicleDtoModel();
    shipment.shipmentDriverDTO = new ShipmentDriverDtoModel();
    return shipment;
  }
}
